import React from 'react';
import { motion } from 'framer-motion';
import { DjayIdentity } from '../../mascot';
import type { FamilyPickerMode } from './types';
interface PickerEmptyStateProps {
  mode: FamilyPickerMode;
  hasPracticedFamilies: boolean;
  hasChallengeReadyFamilies: boolean;
}
export function PickerEmptyState({
  mode,
  hasPracticedFamilies,
  hasChallengeReadyFamilies
}: PickerEmptyStateProps) {
  const isSprintCold = mode === 'sprint' && !hasPracticedFamilies;
  const isChallengeCold = mode === 'challenge' && !hasChallengeReadyFamilies;
  const title = isSprintCold ? 'Eerst even oefenen' : isChallengeCold ? 'Nog geen onderwerpen klaar' : 'Geen onderwerpen gevonden';

  // "Je moet eerst meer oefenen!" las als een terechtwijzing op een scherm dat
  // een kind bereikt door iets goeds te doen: zelf willen oefenen. De boodschap
  // zegt nu hetzelfde zonder verwijt, en noemt de volgende stap.
  const message = isSprintCold ? 'Kies eerst een vak en maak wat vragen. Daarna kun je hier extra trainen op wat nog moeilijk is.' : isChallengeCold ?
  // Geen percentage: leerling-oppervlakken tonen labels, geen getallen
  // (MASTERY_DISPLAY_LANGUAGE_2026).
  'Oefen een onderwerp nog wat vaker. Zodra je het goed onder de knie hebt, kun je hier de uitdaging aan.' : 'Probeer een ander vak.';
  return <motion.div initial={{
    opacity: 0,
    scale: 0.98
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.2,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex flex-col items-center justify-center py-16 text-center px-6" data-id="element-2998" data-mp="1xbsinuhm6hnr">
      
      <div className="mb-4" data-id="element-2999" data-mp="1ocxbaf2u31iv">
        <DjayIdentity size="xl" emotion="thinking" data-id="element-3000" data-mp="1jay5yznj9uja" />
      </div>
      <h3 className="text-xl font-black text-slate-800 mb-2" data-id="element-3001" data-mp="1jdkfh4tzik45">{title}</h3>
      <p className="text-sm text-slate-500 max-w-sm font-medium leading-relaxed" data-id="element-3002" data-mp="1edxzwoqoors6">
        {message}
      </p>
    </motion.div>;
}